export type DateStr = string; // YYYY-MM-DD

export type StreakData = {
  checkins: DateStr[];
  longestStreak: number;
  isFirstVisit: boolean;
  firstCheckinDate: DateStr | null;
};

export const DEFAULT_DATA: StreakData = {
  checkins: [],
  longestStreak: 0,
  isFirstVisit: true,
  firstCheckinDate: null,
};

// Hardcoded for now. Becomes component state when a supplement picker UI is added.
export const SUPPLEMENT = 'creatine';
